(() => {
  function initialise(root) {
    if (root.dataset.plockInitialised) return;
    root.dataset.plockInitialised = 'true';
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-plock-image]');
      if (thumb) {
        const image = root.querySelector('.gg-plock-main-image');
        image.removeAttribute('srcset'); image.src = thumb.dataset.plockImage; image.alt = thumb.dataset.plockAlt;
        root.querySelectorAll('[data-plock-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      }
      const button = event.target.closest('[data-plock-quantity]');
      if (button) {
        const input = root.querySelector('input[name="quantity"]');
        const minimum = Number(input.min) || 1, increment = Number(input.step) || 1;
        let value = Math.max(minimum, (Number(input.value) || minimum) + Number(button.dataset.plockQuantity) * increment);
        if (input.max) value = Math.min(Number(input.max), value);
        input.value = value; input.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
    const select = root.querySelector('[data-plock-variant]');
    if (select) select.addEventListener('change', () => {
      const url = new URL(location.href); url.searchParams.set('variant', select.value); location.assign(url.href);
    });
  }
  function start() { document.querySelectorAll('[data-plock-product]').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
